import { InsightVisibility } from 'redux/schemas/models/exercise';

type AiAssignmentFeedbackManagers = {
  ReportsManager: any;
  CurrentUserManager: any;
  CurrentPermissionsManager: any;
  InstitutionsManager: any;
};

/**
 * Single source of truth for whether AI assignment feedback is visible to the
 * current user. Consumed by the wrapper controller, the nv-individual-submission
 * directive, and the SubmissionRightColumn orchestrator so the permission rules
 * never drift between call sites.
 */
/* @ngInject */
export default function shouldShowAiAssignmentFeedback({
  ReportsManager,
  CurrentUserManager,
  CurrentPermissionsManager,
  InstitutionsManager,
}: AiAssignmentFeedbackManagers): boolean {
  const currentReport = ReportsManager?.currentReport;

  if (!currentReport) {
    return false;
  }

  if (currentReport.exercise?.insightVisibility === InsightVisibility.DISABLED
    || !currentReport.exercise?.aiFeedbackEnabled
    || !InstitutionsManager?.institution?.hasAiComponentGeneration) {
    return false;
  }

  if (CurrentPermissionsManager.isOnlyReportAdmin() || CurrentPermissionsManager.isOnlyConfigAndRegistration()) {
    return false;
  }

  const hasAssignmentViewPermission = CurrentUserManager.isAdminForCurrentCourse()
    || CurrentUserManager.isCourseBuilderForCurrentCourse()
    || CurrentUserManager.isTeachingAssistantForCurrentCourse()
    || CurrentUserManager.isInstructorForCurrentCourse()
    || !!currentReport.isUserMentorOfCollaborators;

  if (hasAssignmentViewPermission) {
    return true;
  }

  const isSubmissionOwner = currentReport.owner?.id === CurrentUserManager?.user?.id;
  const isTeamSubmission = currentReport.ownerType === 'Team'
    && currentReport.exercise?.collaborators?.some(c => c.id === CurrentUserManager?.user?.id);

  if (CurrentPermissionsManager.isLearner() && (isSubmissionOwner || isTeamSubmission)) {
    return currentReport.exercise?.insightVisibility === InsightVisibility.LEARNERS;
  }

  return false;
}
